import React from 'react';
import styled from '@emotion/styled';
import { Shield, AlertCircle, Info } from 'lucide-react';

const PriorityWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const PriorityDisplay = styled.div`
  width: 100%;
  padding: 0.5rem 2rem 0.5rem 2.5rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #374151;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: default;
`;

const PriorityIcon = styled.div`
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: ${props => props.color || '#6b7280'};
  display: flex;
  align-items: center;
`;

const PriorityText = styled.span`
  font-weight: 500;
`;

const PriorityDropdown = ({ 
  value = 'critical',
  options = [
    { value: 'critical', label: 'Critical', icon: Shield, color: '#3b82f6' },
    { value: 'high_exception', label: 'High Exception', icon: AlertCircle, color: '#f59e0b' },
    { value: 'conditional', label: 'Conditional', icon: Info, color: '#6b7280' }
  ]
}) => {
  const selectedOption = options.find(option => option.value === value);
  const PriorityIconComponent = selectedOption ? selectedOption.icon : Shield;

  return (
    <PriorityWrapper>
      <PriorityDisplay>
        <PriorityIcon color={selectedOption?.color || '#3b82f6'}>
          <PriorityIconComponent size={16} />
        </PriorityIcon>
        <PriorityText>{selectedOption ? selectedOption.label : 'Critical'}</PriorityText>
      </PriorityDisplay>
    </PriorityWrapper>
  );
};

export default PriorityDropdown;
